import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Row, Col, Image } from "react-bootstrap";
import { connect } from "react-redux";
import Slider from "react-slick";
import VerifiedBadge from "../Handlers/VerifiedBadge";
import { translate, t } from "react-multi-lang";
import api from "../../Environment";
import "./reactslick.css";

const HomePostUser = (props) => {
  const [user, setUser] = useState([]);

  useEffect(() => {
    setUser(props?.hyperlink_user)
  }, []);

  return (
    // <Col sm={12} md={12} lg={12} xl={12}>
      <div className="col-item" key={user?.user_id}>
        <div className="photo">
          <div className="swiper-slide">
            <div className="b-friend">
              <Link
                to={`/${user?.user_unique_id}`}
                className=""
              >
                <div className="b-friend__cover-wrapper">
                  <Image
                    src={user?.cover ? (api.serviceUrl() + '/' + user?.cover) : '/assets/images/cover-picture.jpg'}
                    alt={user?.username}
                    className="b-friend__cover"
                  />
                </div>
                <div className="b-free-label">
                  {user?.user_account_type_formatted}
                </div>
                <div className="b-friend__content">
                  <div className="b-friend__avatar">
                    <div className="profile-pic">
                      <Image
                        src={user?.picture ? (api.serviceUrl() + '/' + user?.picture) : '/assets/images/upload-profile-img.svg'}
                        alt={user?.username}
                        className="suggest-img"
                      />
                    </div>
                  </div>
                  <div className="b-username-row">
                    <div className="b-username m-like-link">
                      <div className="g-user-name m-lg-size m-verified">
                        {user?.name}{" "}
                        {user?.is_verified_badge == 1 ? (
                          <VerifiedBadge />
                        ) : null}
                      </div>
                    </div>
                  </div>
                  <div className="b-username-row">
                    <div className="b-username">
                      <div className="g-user-username">
                        @{user?.username}
                      </div>
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
    // </Col>
  );
};

const mapStateToPros = (state) => ({
});

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(mapStateToPros, mapDispatchToProps)(translate(HomePostUser));
